import React from "react";
import PropTypes from 'prop-types'
import Textbox from "../Textbox";

const InputName = ({
  onChange,
  person,
  disabled,
  personErrors
}) => (
  <div className="flex flex-wrap md:flex-no-wrap">
    <Textbox
      htmlId="firstName"
      htmlName="firstName"
      type="text"
      value={person.firstName}
      onChange={onChange}
      placeholderI18n="booking.person.firstName"
      placeholder="Enter first name"
      disabled={disabled}
      className="w-full mt-4 md:mt-0 md:mr-2"
      valid={!personErrors.firstName}
    />

    <Textbox
      htmlId="lastName"
      htmlName="lastName"
      type="text"
      value={person.lastName}
      onChange={onChange}
      placeholderI18n="booking.person.lastName"
      placeholder="Enter last name"
      disabled={disabled}
      className="w-full mt-4 md:mt-0 md:ml-2"
      valid={!personErrors.lastName}
    />
  </div>
)

InputName.propTypes = {
  onChange: PropTypes.func.isRequired,
  person: PropTypes.shape({
    person: PropTypes.object
  }).isRequired,
  disabled: PropTypes.bool,
  personErrors: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool
  })
}

InputName.defaultProps = {
  disabled: false,
  personErrors: {
    firstName: false,
    lastName: false
  }
}

export default InputName
  